import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ar',
    lng: localStorage.getItem('nspo_language') || 'ar',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    resources: {
      ar: {
        common: {} // Will be loaded dynamically
      },
      en: {
        common: {}
      },
      fr: {
        common: {}
      }
    }
  });

// Load translation files
const loadTranslations = async () => {
  try {
    const languages = ['ar', 'en', 'fr'];
    for (const lang of languages) {
      const response = await fetch(`/locales/${lang}/common.json`);
      const translations = await response.json();
      i18n.addResourceBundle(lang, 'common', translations);
    }
  } catch (error) {
    console.error('Failed to load translations:', error);
  }
};

loadTranslations();

export default i18n;